var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1514 19.3028C15.203 19.3028 19.3028 15.2121 19.3028 10.1514C19.3028 5.09068 15.203 1 10.1514 1C5.09983 1 1 5.09983 1 10.1514C1 15.203 5.09983 19.3028 10.1514 19.3028Z",
    stroke: "#2F2F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89209 16.4112L16.8779 3.38867",
    stroke: "#2F2F2F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeClose);
export default __webpack_public_path__ + "static/media/office-close.f7b9f71c1fa17197f649a3b294551419.svg";
export { ForwardRef as ReactComponent };